import { Avatar, Box, Typography } from "@mui/material";
import { useMemo } from "react";
import secureLocalStorage from "react-secure-storage";
import { StoredFields } from "../../enums/StoredFields";
import classes from "./Profile.module.scss";
import { OneLoginUser } from "../../interfaces/OneLoginUser";
import ProfilePreferences from "./profile-preferences/ProfilePreferences";

const Profile = () => {
  const oneLoginUser: OneLoginUser = useMemo(() => {
    return Object(secureLocalStorage.getItem(StoredFields.ONE_LOGIN_USER));
  }, []);

  return (
    <>
      <Box className='user-card p-3 d-flex flex-lg-row align-items-center flex-grow-1 mb-1 border justify-content-center justify-content-sm-start'>
        <Box className={`d-flex flex-column flex-lg-row align-items-center`}>
          <Box className="d-flex align-items-center justify-content-center justify-content-lg-start">
            <Avatar
              imgProps={{ referrerPolicy: "no-referrer" }}
              alt={oneLoginUser?.name ?? ''}
              src={oneLoginUser?.avatar ?? ''}
              className={classes["profile-image"]}
            />
          </Box>
          <Box className={'d-flex flex-column mt-3 mt-lg-0 ms-lg-3 px-3 px-lg-0 justify-content-center'}>
            <Typography className={`fw-bold my-2' ${classes['name-text']}`}>{oneLoginUser?.name ?? 'No info available'}</Typography>
            <Typography className={`my-2' ${classes['email-text']}`}>{oneLoginUser?.email ?? 'No info available'}</Typography>
          </Box>
        </Box>
      </Box>
      <ProfilePreferences />
    </>
  );
};

export default Profile;
